import type { CSSProperties } from "react";

import { Flex, Grid, IconButton, Text, Tooltip } from "@radix-ui/themes";

import { LayoutSettingsFieldRowPresentation } from "./LayoutSettingsFieldRow.pres";
import type {
  LayoutSettingChange,
  LayoutSettingSectionView,
} from "./layoutSettings.types";

const SECTION_GRID_STYLE: CSSProperties = {
  gridTemplateColumns: "repeat(auto-fit, minmax(15rem, 1fr))",
};

interface LayoutSettingsSectionPresentationProps {
  panelId: string;
  section: LayoutSettingSectionView;
  onFieldChange: (fieldId: string, change: LayoutSettingChange) => void;
}

export const LayoutSettingsSectionPresentation = ({
  panelId,
  section,
  onFieldChange,
}: LayoutSettingsSectionPresentationProps) => (
  <fieldset>
    <legend>
      <Flex align="center" gap="1">
        <Text size="1" weight="medium">
          {section.label}
        </Text>
        <Tooltip content={section.description} delayDuration={0}>
          <IconButton
            type="button"
            size="1"
            variant="ghost"
            color="gray"
            aria-label={`About ${section.label}`}
          >
            ?
          </IconButton>
        </Tooltip>
      </Flex>
    </legend>
    {/*
      Radix layout props express gap; the auto-fit template comes from the
      one inline style the design contract pins. Anything else Radix could
      express is expressed with Radix.
    */}
    <Grid gap="2" style={SECTION_GRID_STYLE}>
      {section.fields.map((field) => (
        <LayoutSettingsFieldRowPresentation
          key={field.descriptor.id}
          panelId={panelId}
          field={field}
          onFieldChange={onFieldChange}
        />
      ))}
    </Grid>
  </fieldset>
);
